import request from '@/services/request'
import api from '@/services/api'
import dayjs from 'dayjs'
import { reduce, ride } from '@/utils/math'
import apiExpense from '@/services/api/modules/expense'
// eslint-disable-next-line no-unused-vars
import apiCommon from '@/services/api/modules/common'

const state = {
  commonMap: [],
  amazonShopMap: {}, // 亚马逊店铺map  key：shopId,  value: shopName
  amazonCountry: null, // 亚马逊站点信息
  utcTimeOffset: '', // 服务器utc时间与本地时间的偏移量
  operationLabel: [
    { id: 1, name: '销售', color: '#F08BB4', bg: 'rgba(240, 139, 180, 0.1)', border: 'rgba(240, 139, 180, 0.2)' },
    { id: 2, name: '价格', color: '#9661BD', bg: 'rgba(150, 97, 189, 0.1)', border: 'rgba(150, 97, 189, 0.2)' },
    { id: 3, name: 'Listing', color: '#BF77F9', bg: 'rgba(191, 119, 249, 0.1)', border: 'rgba(191, 119, 249, 0.2)' },
    { id: 4, name: '评论', color: '#F69943', bg: '#FEF5EC', border: '#FCE2CA' },
    { id: 5, name: '库存', color: '#3DC9FD', bg: 'rgba(61, 201, 253, 0.1)', border: 'rgba(61, 201, 253, 0.1)' },
    { id: 6, name: '广告', color: '#4687F3', bg: 'rgba(70, 135, 243, 0.1)', border: 'rgba(70, 135, 243, 0.2)' },
    { id: 7, name: '站内活动', color: '#FF7E45', bg: 'rgba(255, 126, 69, 0.1)', border: 'rgba(255, 126, 69, 0.2)' },
    { id: 8, name: '站外活动', color: '#00CCCB', bg: 'rgba(0, 204, 203, 0.1)', border: 'rgba(0, 204, 203, 0.2)' },
    { id: 9, name: '竞品', color: '#33CCA1', bg: 'rgba(51, 204, 161, 0.1)', border: 'rgba(51, 204, 161, 0.5)' },
    { id: 10, name: '排名', color: '#FF7973', bg: 'rgba(255, 121, 115, 0.1)', border: 'rgba(255, 121, 115, 0.2)' },
    { id: 11, name: '流量', color: '#FFB607', bg: 'rgba(255, 179, 67, 0.1)', border: 'rgba(255, 179, 67, 0.2)' },
    { id: 12, name: '市场', color: '#7162FD', bg: 'rgba(113, 98, 253, 0.1)', border: 'rgba(113, 98, 253, 0.2)' },
    { id: 13, name: '其他', color: '#1B8FFF', bg: 'rgba(27, 143, 255, 0.1)', border: 'rgba(27, 143, 255, 0.2)' }
  ],
  feeTypeOptions: [], // 费用类型可选项
  // 所有货币符号的可选项
  // { code, name, label, value }
  allCurrencyOptions: [],
  // 所有平台店铺国家字典, 不仅仅是我们熟知的4个平台, 还有线下等平台
  allPlatformDict: null,
}

const getters = {
  allPlatformOptions: state => {
    return (state.allPlatformDict || []).map(platform => {
      const { platformId, platformName } = platform
      return {
        platformName,
        platformId,
        label: platformName,
        value: platformId,
        name: platformName,
        id: platformId,
      }
    })
  }
}

const mutations = {
  REMOVE_MAP: (state, data) => {
    state.commonMap = []
    state.amazonShopMap = {}
    state.amazonCountry = null
  },
  SET_COMMON_MAP: (state, data) => {
    state.commonMap = data
  },
  SET_AMAZON_SHOP_MAP: (state, data) => {
    state.amazonShopMap = data
  },
  SET_AMAZON_COUNTRY: (state, data) => {
    state.amazonCountry = data
  },
  SET_UTC_TIME_OFFSET: (state, data) => {
    state.utcTimeOffset = data
  },
  SET_FEE_TYPE_OPTIONS: (state, data) => {
    state.feeTypeOptions = data || []
  },
  SET_ALL_CURRENCY_OPTIONS: (state, data) => {
    state.allCurrencyOptions = data || []
  },
  SET_ALL_PLATFORM_DICT: (state, data) => {
    state.allPlatformDict = data
  },
}

const actions = {
  // 获取关联关系的map
  getCommonMap({ state, commit }) {
    return new Promise((resolve, reject) => {
      request(api.common.getShopCountryInfo).then(response => {
        const { code, data } = response
        if (code === 200) {
          const newData = []
          const amazonShopMap = {}
          data.forEach(map => {
            map.shopList.forEach(shop => {
              shop.countryList.forEach(country => {
                if (map.platformId === 3) {
                  amazonShopMap[country.shopId] = `${shop.shopName}-${country.countryCode}`
                }
                newData.push({ ...country, shopName: shop.shopName, platformId: map.platformId, platformName: map.platformName })
              })
            })
          })
          commit('SET_AMAZON_SHOP_MAP', amazonShopMap)
          commit('SET_COMMON_MAP', newData)
          resolve(newData)
        } else {
          reject(new Error())
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取亚马逊站点信息
  async getAmazonCountry({ state, commit }) {
    if (state.amazonCountry) return state.amazonCountry
    const { code, data } = await request(api.common.getAmazonCountry)
    if (code === 200) {
      commit('SET_AMAZON_COUNTRY', data)
      return data
    }
    return state.amazonCountry
  },
  getUtcTime({ state, commit }) {
    return new Promise((resolve, reject) => {
      request(api.common.getUTCTime).then(response => {
        const { code, data } = response
        if (code === 200) {
          const offets = reduce(ride(data, 1000), dayjs().valueOf())
          commit('SET_UTC_TIME_OFFSET', offets)
          resolve()
        } else if (code === 401 || code === 40022) {
          resolve(code)
        } else {
          reject(new Error())
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  async updateFeeTypeOPtions({ state, commit }) {
    try {
      const res = await apiExpense.fetchAllFeeType()
      const { code, data } = res
      if (code !== 200) {
        return
      }

      const options = (data || []).map(item => {
        return {
          id: item.id,
          name: item.typeName
        }
      })
      commit('SET_FEE_TYPE_OPTIONS', options)
    } catch (err) {
      console.log(err)
    }
  },
  async flushAllCurrencyOPtions({ state, commit }) {
    try {
      // 显示所有的货币符号，接口获取
      const { code, data } = await apiExpense.fetchCurrencyCodeList() || {}
      if (code === 200) {
        const options = data.map((item) => {
          const { code, name, symbol } = item
          return {
            ...item,
            currencyCode: code,
            currencyName: name,
            currencySymbol: symbol,
            label: `${code} - ${name}`,
            value: code
          }
        })
        commit('SET_ALL_CURRENCY_OPTIONS', options)
      }
    } catch (err) {
      console.log(err)
    }
  },
  async getAllPlatformDict({ state, commit }) {
    if (state.allPlatformDict) return state.allPlatformDict

    try {
      const { code, data } = await apiCommon.fetchAllPlatformDict()
      if (code !== 200) {
        throw new Error('code !== 200')
      }

      commit('SET_ALL_PLATFORM_DICT', data)
    } catch (error) {
      console.log(error)
    }

    return state.allPlatformDict || []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
